module.exports = __webpack_public_path__ + "img/PL08313.1461f5cc.png";